import { Card, Col, Container, Image, Row } from "@themesberg/react-bootstrap";
import NotFoundImage from "../assets/404.svg";

const NotFound = ({ isData }) => {
	return (
		<main>
			<section className="vh-50 d-flex align-items-center justify-content-center">
				<Container>
					<Row>
						<Col
							xs={12}
							className="text-center d-flex align-items-center justify-content-center"
						>
							<div>
								<Card.Link>
									<Image src={NotFoundImage} className="img-fluid w-75" />
								</Card.Link>
								<h1 className="text-primary mt-5">
									{isData && (
										<>
											No data <span className="fw-bolder">found</span>
										</>
									)}

									{!isData && (
										<>
											Page not <span className="fw-bolder">found</span>
										</>
									)}
								</h1>
								<p className="lead my-4">
									{!isData ? (
										<>Oops! Looks like you followed a bad link.</>
									) : (
										<>Oops! Looks like no data matched your request.</>
									)}
								</p>
							</div>
						</Col>
					</Row>
				</Container>
			</section>
		</main>
	);
};

export default NotFound;
